import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField';

import { setEstablishmentId } from 'pages/BusinessInfo/store/actions';

import { useStyles } from './styles';

const AutocompleteComponent = ({ options, onChange, value }) => {
  const dispatch = useDispatch();

  const classes = useStyles({ value });

  const { selects } = useSelector(state => state.filters);
  const { isAdminUser } = useSelector(state => state.profile.submit);

  const isUserAdmin = +isAdminUser == 1;

  const jumpResales = selects
    ?.find(select => select?.id == 'resale')?.options
    ?.filter(option => !!option?.id);

  const uniqueEstablishments = [...new Map(options?.map(establishment => [establishment['establishmentId'], establishment])).values()];

  const uniqueEstablishmentsWithoutAllEstablishments = uniqueEstablishments
    ?.filter(establishment => !!establishment?.establishmentId);

  const isSingleEstablishment = uniqueEstablishments
    ?.filter(establishment => !!establishment?.establishmentId)
    ?.length == 1;

  useEffect(() => {
    if(isSingleEstablishment) {
      dispatch(setEstablishmentId({ establishmentId: uniqueEstablishmentsWithoutAllEstablishments[0]?.establishmentId }));
    }
  }, [isSingleEstablishment]);

  const optionValue = () => {
    if(options.length > 0) {
      if (value) {
        return options.filter(opt => opt.value === value)[0];
      }

      return options[0];
    }

    return {}
  }

  const filterOptions = (options, state) => {
    const OPTIONS_LIMIT = 500;
    const defaultFilterOptions = createFilterOptions();

    return defaultFilterOptions(options, state).slice(0, OPTIONS_LIMIT);
  }

  return(
    <Autocomplete
      id="autocomplete"
      openOnFocus
      disableClearable
      options={isSingleEstablishment ? uniqueEstablishmentsWithoutAllEstablishments : uniqueEstablishments}
      onChange={onChange}
      value={optionValue()}
      classes={classes}
      fullWidth
      getOptionLabel={option => option.label}
      filterOptions={filterOptions}
      renderInput={params => (
        <TextField
          {...params}
          multiline
          variant="outlined"
        />
      )}
      renderOption={props => {
        const { label, resaleId } = props;

        const hexColor = isUserAdmin
          ? jumpResales?.find(resale => resale?.id == resaleId)?.hexColor
          : 'none';

        return(
          <span
            {...props}
            style={{ backgroundColor: hexColor, color: '#1E5168', padding: 10, width: '100%' }}
          >
            {label}
          </span>
        );
      }}
    />
  );
}

AutocompleteComponent.defaultProps = {
  options: [],
  value: ''
}

AutocompleteComponent.propTypes = {
  options: PropTypes.arrayOf(),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export { AutocompleteComponent };